module.exports = __webpack_public_path__ + "static/media/pro-freelancer-2.e3071e43.webp";